type Env  = "production" | "staging";

export const env = process.env.APP_ENV as Env || "production";

const endpointsByEnv = {
  production: {
    api: "https://api.shoppbud.com.br",
    RECAPTCHA_SITE_KEY: "6Ld5xRsrAAAAAN3hnJE9HeL-CCW5J_l2MH9Le7H1"
  },
  staging: {
    api: "https://api.staging.shoppbud.com.br",
    RECAPTCHA_SITE_KEY: "6LeKhBorAAAAALXR4jCoP4n7clvTFw8RmKy8mTf7"
  },
} as const;

export const endpoints = endpointsByEnv[env] || endpointsByEnv.production;

const values = {
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY || ''
}

export default values;